import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BeansAuctionHouse
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const beansAuctionHouseAbi = [
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'extended', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'AuctionBid',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'startTime',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endTime',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'endTime',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionExtended',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minBidIncrementPercentage',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionMinBidIncrementPercentageUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reservePrice',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionReservePriceUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beanId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'winner',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'amount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionSettled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'timeBuffer',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AuctionTimeBufferUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'version', internalType: 'uint8', type: 'uint8', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Paused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'Unpaused',
  },
  {
    type: 'function',
    inputs: [],
    name: 'auction',
    outputs: [
      { name: 'beanId', internalType: 'uint256', type: 'uint256' },
      { name: 'amount', internalType: 'uint256', type: 'uint256' },
      { name: 'startTime', internalType: 'uint256', type: 'uint256' },
      { name: 'endTime', internalType: 'uint256', type: 'uint256' },
      { name: 'bidder', internalType: 'address payable', type: 'address' },
      { name: 'settled', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'beans',
    outputs: [
      { name: '', internalType: 'contract IBeansToken', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'beanId', internalType: 'uint256', type: 'uint256' }],
    name: 'createBid',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'duration',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_beans', internalType: 'address', type: 'address' },
      { name: '_weth', internalType: 'address', type: 'address' },
      { name: '_timeBuffer', internalType: 'uint256', type: 'uint256' },
      { name: '_reservePrice', internalType: 'uint256', type: 'uint256' },
      {
        name: '_minBidIncrementPercentage',
        internalType: 'uint8',
        type: 'uint8',
      },
      { name: '_duration', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'minBidIncrementPercentage',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'paused',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'reservePrice',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_minBidIncrementPercentage',
        internalType: 'uint8',
        type: 'uint8',
      },
    ],
    name: 'setMinBidIncrementPercentage',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_reservePrice', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setReservePrice',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_timeBuffer', internalType: 'uint256', type: 'uint256' }],
    name: 'setTimeBuffer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'settleAuction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'settleCurrentAndCreateNewAuction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'timeBuffer',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'weth',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
] as const

export const beansAuctionHouseAddress =
  '0xE56a5C5761467888ad95E43a5B172A631C15E376' as const

export const beansAuctionHouseConfig = {
  address: beansAuctionHouseAddress,
  abi: beansAuctionHouseAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BeansDao
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const beansDaoAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: 'timelock_', internalType: 'address', type: 'address' },
      { name: 'beans_', internalType: 'address', type: 'address' },
      { name: 'vetoer_', internalType: 'address', type: 'address' },
      { name: 'admin_', internalType: 'address', type: 'address' },
      { name: 'implementation_', internalType: 'address', type: 'address' },
      { name: 'votingPeriod_', internalType: 'uint256', type: 'uint256' },
      { name: 'votingDelay_', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposalThresholdBPS_',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'quorumVotesBPS_', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldImplementation',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newImplementation',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewImplementation',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldPendingAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newPendingAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewPendingAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVetoer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newVetoer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewVetoer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'proposer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'targets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'signatures',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
      {
        name: 'calldatas',
        internalType: 'bytes[]',
        type: 'bytes[]',
        indexed: false,
      },
      {
        name: 'startBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'description',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'ProposalCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'proposer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'targets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'signatures',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
      {
        name: 'calldatas',
        internalType: 'bytes[]',
        type: 'bytes[]',
        indexed: false,
      },
      {
        name: 'startBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'proposalThreshold',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'quorumVotes',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'description',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'ProposalCreatedWithRequirements',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalExecuted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      { name: 'eta', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalQueued',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldProposalThresholdBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newProposalThresholdBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ProposalThresholdBPSSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalVetoed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldQuorumVotesBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newQuorumVotesBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'QuorumVotesBPSSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'voter',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proposalId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'support', internalType: 'uint8', type: 'uint8', indexed: false },
      {
        name: 'votes',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reason',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'VoteCast',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVotingDelay',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newVotingDelay',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'VotingDelaySet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVotingPeriod',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newVotingPeriod',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'VotingPeriodSet',
  },
  { type: 'fallback', stateMutability: 'payable' },
  {
    type: 'function',
    inputs: [
      { name: 'implementation_', internalType: 'address', type: 'address' },
    ],
    name: '_setImplementation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  { type: 'receive', stateMutability: 'payable' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldImplementation',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newImplementation',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewImplementation',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldPendingAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newPendingAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewPendingAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVetoer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newVetoer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'NewVetoer',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalCanceled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'proposer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'targets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'signatures',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
      {
        name: 'calldatas',
        internalType: 'bytes[]',
        type: 'bytes[]',
        indexed: false,
      },
      {
        name: 'startBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'description',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'ProposalCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      {
        name: 'proposer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'targets',
        internalType: 'address[]',
        type: 'address[]',
        indexed: false,
      },
      {
        name: 'values',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
      {
        name: 'signatures',
        internalType: 'string[]',
        type: 'string[]',
        indexed: false,
      },
      {
        name: 'calldatas',
        internalType: 'bytes[]',
        type: 'bytes[]',
        indexed: false,
      },
      {
        name: 'startBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'proposalThreshold',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'quorumVotes',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'description',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'ProposalCreatedWithRequirements',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalExecuted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
      { name: 'eta', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalQueued',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldProposalThresholdBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newProposalThresholdBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ProposalThresholdBPSSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'ProposalVetoed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldQuorumVotesBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newQuorumVotesBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'QuorumVotesBPSSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'voter',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'proposalId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'support', internalType: 'uint8', type: 'uint8', indexed: false },
      {
        name: 'votes',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reason',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'VoteCast',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVotingDelay',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newVotingDelay',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'VotingDelaySet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'oldVotingPeriod',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newVotingPeriod',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'VotingPeriodSet',
  },
  {
    type: 'function',
    inputs: [],
    name: 'BALLOT_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_PROPOSAL_THRESHOLD_BPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_QUORUM_VOTES_BPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_VOTING_DELAY',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_VOTING_PERIOD',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MIN_PROPOSAL_THRESHOLD_BPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MIN_QUORUM_VOTES_BPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MIN_VOTING_DELAY',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MIN_VOTING_PERIOD',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: '_acceptAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: '_burnVetoPower',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingAdmin', internalType: 'address', type: 'address' },
    ],
    name: '_setPendingAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'newProposalThresholdBPS',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: '_setProposalThresholdBPS',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newQuorumVotesBPS', internalType: 'uint256', type: 'uint256' },
    ],
    name: '_setQuorumVotesBPS',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newVetoer', internalType: 'address', type: 'address' }],
    name: '_setVetoer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newVotingDelay', internalType: 'uint256', type: 'uint256' },
    ],
    name: '_setVotingDelay',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newVotingPeriod', internalType: 'uint256', type: 'uint256' },
    ],
    name: '_setVotingPeriod',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'admin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'beans',
    outputs: [
      { name: '', internalType: 'contract BeansTokenLike', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'cancel',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
      { name: 'support', internalType: 'uint8', type: 'uint8' },
    ],
    name: 'castVote',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
      { name: 'support', internalType: 'uint8', type: 'uint8' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'castVoteBySig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
      { name: 'support', internalType: 'uint8', type: 'uint8' },
      { name: 'reason', internalType: 'string', type: 'string' },
    ],
    name: 'castVoteWithReason',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'execute',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'getActions',
    outputs: [
      { name: 'targets', internalType: 'address[]', type: 'address[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'signatures', internalType: 'string[]', type: 'string[]' },
      { name: 'calldatas', internalType: 'bytes[]', type: 'bytes[]' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'proposalId', internalType: 'uint256', type: 'uint256' },
      { name: 'voter', internalType: 'address', type: 'address' },
    ],
    name: 'getReceipt',
    outputs: [
      {
        name: '',
        internalType: 'struct BeansDAOStorageV1.Receipt',
        type: 'tuple',
        components: [
          { name: 'hasVoted', internalType: 'bool', type: 'bool' },
          { name: 'support', internalType: 'uint8', type: 'uint8' },
          { name: 'votes', internalType: 'uint96', type: 'uint96' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'implementation',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'timelock_', internalType: 'address', type: 'address' },
      { name: 'beans_', internalType: 'address', type: 'address' },
      { name: 'vetoer_', internalType: 'address', type: 'address' },
      { name: 'votingPeriod_', internalType: 'uint256', type: 'uint256' },
      { name: 'votingDelay_', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposalThresholdBPS_',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'quorumVotesBPS_', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'latestProposalIds',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingAdmin',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proposalCount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proposalMaxOperations',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proposalThreshold',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proposalThresholdBPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'proposals',
    outputs: [
      { name: 'id', internalType: 'uint256', type: 'uint256' },
      { name: 'proposer', internalType: 'address', type: 'address' },
      { name: 'proposalThreshold', internalType: 'uint256', type: 'uint256' },
      { name: 'quorumVotes', internalType: 'uint256', type: 'uint256' },
      { name: 'eta', internalType: 'uint256', type: 'uint256' },
      { name: 'startBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'endBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'forVotes', internalType: 'uint256', type: 'uint256' },
      { name: 'againstVotes', internalType: 'uint256', type: 'uint256' },
      { name: 'abstainVotes', internalType: 'uint256', type: 'uint256' },
      { name: 'canceled', internalType: 'bool', type: 'bool' },
      { name: 'vetoed', internalType: 'bool', type: 'bool' },
      { name: 'executed', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'targets', internalType: 'address[]', type: 'address[]' },
      { name: 'values', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'signatures', internalType: 'string[]', type: 'string[]' },
      { name: 'calldatas', internalType: 'bytes[]', type: 'bytes[]' },
      { name: 'description', internalType: 'string', type: 'string' },
    ],
    name: 'propose',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'queue',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quorumVotes',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quorumVotesBPS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'state',
    outputs: [
      {
        name: '',
        internalType: 'enum BeansDAOStorageV1.ProposalState',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'timelock',
    outputs: [
      { name: '', internalType: 'contract IBeansDAOExecutor', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'proposalId', internalType: 'uint256', type: 'uint256' }],
    name: 'veto',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'vetoer',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'votingDelay',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'votingPeriod',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const

export const beansDaoAddress =
  '0x6fd4c9305AFeA8dF6Fa6039F7F8037D34025E338' as const

export const beansDaoConfig = {
  address: beansDaoAddress,
  abi: beansDaoAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BeansToken
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const beansTokenAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_beanteamDAO', internalType: 'address', type: 'address' },
      { name: '_minter', internalType: 'address', type: 'address' },
      { name: '_descriptor', internalType: 'address', type: 'address' },
      { name: '_seeder', internalType: 'address', type: 'address' },
      {
        name: '_proxyRegistry',
        internalType: 'contract IProxyRegistry',
        type: 'address',
      },
      { name: '_ogBeans', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'approved',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'owner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'operator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'approved', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ApprovalForAll',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'BeanBurned',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'typeRef',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'BeanCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beanteamDAO',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'BeanteamDAOUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'delegator',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'fromDelegate',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'toDelegate',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'DelegateChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'delegate',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'previousBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newBalance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DelegateVotesChanged',
  },
  { type: 'event', anonymous: false, inputs: [], name: 'DescriptorLocked' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'descriptor',
        internalType: 'contract IBeansDescriptor',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'DescriptorUpdated',
  },
  { type: 'event', anonymous: false, inputs: [], name: 'MinterLocked' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minter',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'MinterUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'ogBeanAddy',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'OgBeanMinted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  { type: 'event', anonymous: false, inputs: [], name: 'SeederLocked' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'seeder',
        internalType: 'contract IBeansSeeder',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'SeederUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'from', internalType: 'address', type: 'address', indexed: true },
      { name: 'to', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'tokenId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DELEGATION_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'DOMAIN_TYPEHASH',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: '_dataURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'owner', internalType: 'address', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'beanteamDAO',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'beanId', internalType: 'uint256', type: 'uint256' }],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'address', type: 'address' },
      { name: '', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'checkpoints',
    outputs: [
      { name: 'fromBlock', internalType: 'uint32', type: 'uint32' },
      { name: 'votes', internalType: 'uint96', type: 'uint96' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'contractURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ name: '', internalType: 'uint8', type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'delegatee', internalType: 'address', type: 'address' }],
    name: 'delegate',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'delegatee', internalType: 'address', type: 'address' },
      { name: 'nonce', internalType: 'uint256', type: 'uint256' },
      { name: 'expiry', internalType: 'uint256', type: 'uint256' },
      { name: 'v', internalType: 'uint8', type: 'uint8' },
      { name: 'r', internalType: 'bytes32', type: 'bytes32' },
      { name: 's', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'delegateBySig',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'delegator', internalType: 'address', type: 'address' }],
    name: 'delegates',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'descriptor',
    outputs: [
      { name: '', internalType: 'contract IBeansDescriptor', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'getApproved',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', internalType: 'address', type: 'address' }],
    name: 'getCurrentVotes',
    outputs: [{ name: '', internalType: 'uint96', type: 'uint96' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'blockNumber', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPriorVotes',
    outputs: [{ name: '', internalType: 'uint96', type: 'uint96' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'beanId', internalType: 'uint256', type: 'uint256' }],
    name: 'getSeed',
    outputs: [
      {
        name: '',
        internalType: 'struct IBeansSeeder.Seed',
        type: 'tuple',
        components: [
          { name: 'classOne', internalType: 'uint256', type: 'uint256' },
          { name: 'classTwo', internalType: 'uint256', type: 'uint256' },
          { name: 'size', internalType: 'uint256', type: 'uint256' },
          { name: 'helmetLib', internalType: 'uint256', type: 'uint256' },
          { name: 'helmet', internalType: 'uint256', type: 'uint256' },
          { name: 'gearLib', internalType: 'uint256', type: 'uint256' },
          { name: 'gear', internalType: 'uint256', type: 'uint256' },
          { name: 'vibe', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'operator', internalType: 'address', type: 'address' },
    ],
    name: 'isApprovedForAll',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isDescriptorLocked',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isMinterLocked',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isSeederLocked',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lockDescriptor',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lockMinter',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'lockSeeder',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'mint',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'classOne', internalType: 'uint256', type: 'uint256' },
      { name: 'classTwo', internalType: 'uint256', type: 'uint256' },
      { name: 'size', internalType: 'uint256', type: 'uint256' },
      { name: 'helmetLib', internalType: 'uint256', type: 'uint256' },
      { name: 'helmet', internalType: 'uint256', type: 'uint256' },
      { name: 'gearLib', internalType: 'uint256', type: 'uint256' },
      { name: 'gear', internalType: 'uint256', type: 'uint256' },
      { name: 'vibe', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'mintOriginalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'minter',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'nonces',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'numCheckpoints',
    outputs: [{ name: '', internalType: 'uint32', type: 'uint32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ogBeansList',
    outputs: [
      { name: '', internalType: 'contract IOGBeansList', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proxyRegistry',
    outputs: [
      { name: '', internalType: 'contract IProxyRegistry', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
      { name: '_data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'seeder',
    outputs: [
      { name: '', internalType: 'contract IBeansSeeder', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'seeds',
    outputs: [
      { name: 'classOne', internalType: 'uint256', type: 'uint256' },
      { name: 'classTwo', internalType: 'uint256', type: 'uint256' },
      { name: 'size', internalType: 'uint256', type: 'uint256' },
      { name: 'helmetLib', internalType: 'uint256', type: 'uint256' },
      { name: 'helmet', internalType: 'uint256', type: 'uint256' },
      { name: 'gearLib', internalType: 'uint256', type: 'uint256' },
      { name: 'gear', internalType: 'uint256', type: 'uint256' },
      { name: 'vibe', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'operator', internalType: 'address', type: 'address' },
      { name: 'approved', internalType: 'bool', type: 'bool' },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_beanteamDAO', internalType: 'address', type: 'address' },
    ],
    name: 'setBeanteamDAO',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newContractURIHash', internalType: 'string', type: 'string' },
    ],
    name: 'setContractURIHash',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_descriptor',
        internalType: 'contract IBeansDescriptor',
        type: 'address',
      },
    ],
    name: 'setDescriptor',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_minter', internalType: 'address', type: 'address' }],
    name: 'setMinter',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_seeder',
        internalType: 'contract IBeansSeeder',
        type: 'address',
      },
    ],
    name: 'setSeeder',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'interfaceId', internalType: 'bytes4', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'index', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenByIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', internalType: 'address', type: 'address' },
      { name: 'index', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'tokenOfOwnerByIndex',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'tokenId', internalType: 'uint256', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ name: '', internalType: 'string', type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'from', internalType: 'address', type: 'address' },
      { name: 'to', internalType: 'address', type: 'address' },
      { name: 'tokenId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'delegator', internalType: 'address', type: 'address' }],
    name: 'votesToDelegate',
    outputs: [{ name: '', internalType: 'uint96', type: 'uint96' }],
    stateMutability: 'view',
  },
] as const

export const beansTokenAddress =
  '0x65EB64E86b71f8Be76b2aedacE781209Db25879D' as const

export const beansTokenConfig = {
  address: beansTokenAddress,
  abi: beansTokenAbi,
} as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__
 */
export const useReadBeansAuctionHouse = /*#__PURE__*/ createUseReadContract({
  abi: beansAuctionHouseAbi,
  address: beansAuctionHouseAddress,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"auction"`
 */
export const useReadBeansAuctionHouseAuction =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'auction',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"beans"`
 */
export const useReadBeansAuctionHouseBeans =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'beans',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"duration"`
 */
export const useReadBeansAuctionHouseDuration =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'duration',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"minBidIncrementPercentage"`
 */
export const useReadBeansAuctionHouseMinBidIncrementPercentage =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'minBidIncrementPercentage',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"owner"`
 */
export const useReadBeansAuctionHouseOwner =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'owner',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"paused"`
 */
export const useReadBeansAuctionHousePaused =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'paused',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"reservePrice"`
 */
export const useReadBeansAuctionHouseReservePrice =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'reservePrice',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"timeBuffer"`
 */
export const useReadBeansAuctionHouseTimeBuffer =
  /*#__PURE__*/ createUseReadContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'timeBuffer',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"weth"`
 */
export const useReadBeansAuctionHouseWeth = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'weth',
  },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__
 */
export const useWriteBeansAuctionHouse = /*#__PURE__*/ createUseWriteContract({
  abi: beansAuctionHouseAbi,
  address: beansAuctionHouseAddress,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"createBid"`
 */
export const useWriteBeansAuctionHouseCreateBid =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'createBid',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteBeansAuctionHouseInitialize =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"pause"`
 */
export const useWriteBeansAuctionHousePause =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'pause',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteBeansAuctionHouseRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setMinBidIncrementPercentage"`
 */
export const useWriteBeansAuctionHouseSetMinBidIncrementPercentage =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setMinBidIncrementPercentage',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setReservePrice"`
 */
export const useWriteBeansAuctionHouseSetReservePrice =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setReservePrice',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setTimeBuffer"`
 */
export const useWriteBeansAuctionHouseSetTimeBuffer =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setTimeBuffer',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"settleAuction"`
 */
export const useWriteBeansAuctionHouseSettleAuction =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'settleAuction',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"settleCurrentAndCreateNewAuction"`
 */
export const useWriteBeansAuctionHouseSettleCurrentAndCreateNewAuction =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'settleCurrentAndCreateNewAuction',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteBeansAuctionHouseTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"unpause"`
 */
export const useWriteBeansAuctionHouseUnpause =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'unpause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__
 */
export const useSimulateBeansAuctionHouse =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"createBid"`
 */
export const useSimulateBeansAuctionHouseCreateBid =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'createBid',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateBeansAuctionHouseInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"pause"`
 */
export const useSimulateBeansAuctionHousePause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'pause',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateBeansAuctionHouseRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setMinBidIncrementPercentage"`
 */
export const useSimulateBeansAuctionHouseSetMinBidIncrementPercentage =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setMinBidIncrementPercentage',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setReservePrice"`
 */
export const useSimulateBeansAuctionHouseSetReservePrice =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setReservePrice',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"setTimeBuffer"`
 */
export const useSimulateBeansAuctionHouseSetTimeBuffer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'setTimeBuffer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"settleAuction"`
 */
export const useSimulateBeansAuctionHouseSettleAuction =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'settleAuction',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"settleCurrentAndCreateNewAuction"`
 */
export const useSimulateBeansAuctionHouseSettleCurrentAndCreateNewAuction =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'settleCurrentAndCreateNewAuction',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateBeansAuctionHouseTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `functionName` set to `"unpause"`
 */
export const useSimulateBeansAuctionHouseUnpause =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    functionName: 'unpause',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__
 */
export const useWatchBeansAuctionHouseEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionBid"`
 */
export const useWatchBeansAuctionHouseAuctionBidEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionBid',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionCreated"`
 */
export const useWatchBeansAuctionHouseAuctionCreatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionCreated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionExtended"`
 */
export const useWatchBeansAuctionHouseAuctionExtendedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionExtended',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionMinBidIncrementPercentageUpdated"`
 */
export const useWatchBeansAuctionHouseAuctionMinBidIncrementPercentageUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionMinBidIncrementPercentageUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionReservePriceUpdated"`
 */
export const useWatchBeansAuctionHouseAuctionReservePriceUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionReservePriceUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionSettled"`
 */
export const useWatchBeansAuctionHouseAuctionSettledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionSettled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"AuctionTimeBufferUpdated"`
 */
export const useWatchBeansAuctionHouseAuctionTimeBufferUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'AuctionTimeBufferUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchBeansAuctionHouseInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchBeansAuctionHouseOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"Paused"`
 */
export const useWatchBeansAuctionHousePausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'Paused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansAuctionHouseAbi}__ and `eventName` set to `"Unpaused"`
 */
export const useWatchBeansAuctionHouseUnpausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansAuctionHouseAbi,
    address: beansAuctionHouseAddress,
    eventName: 'Unpaused',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__
 */
export const useReadBeansDao = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"admin"`
 */
export const useReadBeansDaoAdmin = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'admin',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"implementation"`
 */
export const useReadBeansDaoImplementation =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'implementation',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"pendingAdmin"`
 */
export const useReadBeansDaoPendingAdmin = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'pendingAdmin',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"BALLOT_TYPEHASH"`
 */
export const useReadBeansDaoBallotTypehash =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'BALLOT_TYPEHASH',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"DOMAIN_TYPEHASH"`
 */
export const useReadBeansDaoDomainTypehash =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'DOMAIN_TYPEHASH',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MAX_PROPOSAL_THRESHOLD_BPS"`
 */
export const useReadBeansDaoMaxProposalThresholdBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MAX_PROPOSAL_THRESHOLD_BPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MAX_QUORUM_VOTES_BPS"`
 */
export const useReadBeansDaoMaxQuorumVotesBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MAX_QUORUM_VOTES_BPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MAX_VOTING_DELAY"`
 */
export const useReadBeansDaoMaxVotingDelay =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MAX_VOTING_DELAY',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MAX_VOTING_PERIOD"`
 */
export const useReadBeansDaoMaxVotingPeriod =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MAX_VOTING_PERIOD',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MIN_PROPOSAL_THRESHOLD_BPS"`
 */
export const useReadBeansDaoMinProposalThresholdBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MIN_PROPOSAL_THRESHOLD_BPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MIN_QUORUM_VOTES_BPS"`
 */
export const useReadBeansDaoMinQuorumVotesBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MIN_QUORUM_VOTES_BPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MIN_VOTING_DELAY"`
 */
export const useReadBeansDaoMinVotingDelay =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MIN_VOTING_DELAY',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"MIN_VOTING_PERIOD"`
 */
export const useReadBeansDaoMinVotingPeriod =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'MIN_VOTING_PERIOD',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"beans"`
 */
export const useReadBeansDaoBeans = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'beans',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"getActions"`
 */
export const useReadBeansDaoGetActions = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'getActions',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"getReceipt"`
 */
export const useReadBeansDaoGetReceipt = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'getReceipt',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"latestProposalIds"`
 */
export const useReadBeansDaoLatestProposalIds =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'latestProposalIds',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"name"`
 */
export const useReadBeansDaoName = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"proposalCount"`
 */
export const useReadBeansDaoProposalCount = /*#__PURE__*/ createUseReadContract(
  { abi: beansDaoAbi, address: beansDaoAddress, functionName: 'proposalCount' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"proposalMaxOperations"`
 */
export const useReadBeansDaoProposalMaxOperations =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'proposalMaxOperations',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"proposalThreshold"`
 */
export const useReadBeansDaoProposalThreshold =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'proposalThreshold',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"proposalThresholdBPS"`
 */
export const useReadBeansDaoProposalThresholdBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'proposalThresholdBPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"proposals"`
 */
export const useReadBeansDaoProposals = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'proposals',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"quorumVotes"`
 */
export const useReadBeansDaoQuorumVotes = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'quorumVotes',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"quorumVotesBPS"`
 */
export const useReadBeansDaoQuorumVotesBps =
  /*#__PURE__*/ createUseReadContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'quorumVotesBPS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"state"`
 */
export const useReadBeansDaoState = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'state',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"timelock"`
 */
export const useReadBeansDaoTimelock = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'timelock',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"vetoer"`
 */
export const useReadBeansDaoVetoer = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'vetoer',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"votingDelay"`
 */
export const useReadBeansDaoVotingDelay = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'votingDelay',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"votingPeriod"`
 */
export const useReadBeansDaoVotingPeriod = /*#__PURE__*/ createUseReadContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'votingPeriod',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__
 */
export const useWriteBeansDao = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setImplementation"`
 */
export const useWriteBeansDaoSetImplementation =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setImplementation',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_acceptAdmin"`
 */
export const useWriteBeansDaoAcceptAdmin = /*#__PURE__*/ createUseWriteContract(
  { abi: beansDaoAbi, address: beansDaoAddress, functionName: '_acceptAdmin' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_burnVetoPower"`
 */
export const useWriteBeansDaoBurnVetoPower =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_burnVetoPower',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setPendingAdmin"`
 */
export const useWriteBeansDaoSetPendingAdmin =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setPendingAdmin',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setProposalThresholdBPS"`
 */
export const useWriteBeansDaoSetProposalThresholdBps =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setProposalThresholdBPS',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setQuorumVotesBPS"`
 */
export const useWriteBeansDaoSetQuorumVotesBps =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setQuorumVotesBPS',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVetoer"`
 */
export const useWriteBeansDaoSetVetoer = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: '_setVetoer',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVotingDelay"`
 */
export const useWriteBeansDaoSetVotingDelay =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setVotingDelay',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVotingPeriod"`
 */
export const useWriteBeansDaoSetVotingPeriod =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setVotingPeriod',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"cancel"`
 */
export const useWriteBeansDaoCancel = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'cancel',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVote"`
 */
export const useWriteBeansDaoCastVote = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'castVote',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVoteBySig"`
 */
export const useWriteBeansDaoCastVoteBySig =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'castVoteBySig',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVoteWithReason"`
 */
export const useWriteBeansDaoCastVoteWithReason =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'castVoteWithReason',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"execute"`
 */
export const useWriteBeansDaoExecute = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'execute',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteBeansDaoInitialize = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'initialize',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"propose"`
 */
export const useWriteBeansDaoPropose = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'propose',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"queue"`
 */
export const useWriteBeansDaoQueue = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'queue',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"veto"`
 */
export const useWriteBeansDaoVeto = /*#__PURE__*/ createUseWriteContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'veto',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__
 */
export const useSimulateBeansDao = /*#__PURE__*/ createUseSimulateContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setImplementation"`
 */
export const useSimulateBeansDaoSetImplementation =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setImplementation',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_acceptAdmin"`
 */
export const useSimulateBeansDaoAcceptAdmin =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_acceptAdmin',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_burnVetoPower"`
 */
export const useSimulateBeansDaoBurnVetoPower =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_burnVetoPower',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setPendingAdmin"`
 */
export const useSimulateBeansDaoSetPendingAdmin =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setPendingAdmin',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setProposalThresholdBPS"`
 */
export const useSimulateBeansDaoSetProposalThresholdBps =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setProposalThresholdBPS',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setQuorumVotesBPS"`
 */
export const useSimulateBeansDaoSetQuorumVotesBps =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setQuorumVotesBPS',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVetoer"`
 */
export const useSimulateBeansDaoSetVetoer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setVetoer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVotingDelay"`
 */
export const useSimulateBeansDaoSetVotingDelay =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setVotingDelay',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"_setVotingPeriod"`
 */
export const useSimulateBeansDaoSetVotingPeriod =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: '_setVotingPeriod',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"cancel"`
 */
export const useSimulateBeansDaoCancel =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'cancel',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVote"`
 */
export const useSimulateBeansDaoCastVote =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'castVote',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVoteBySig"`
 */
export const useSimulateBeansDaoCastVoteBySig =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'castVoteBySig',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"castVoteWithReason"`
 */
export const useSimulateBeansDaoCastVoteWithReason =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'castVoteWithReason',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"execute"`
 */
export const useSimulateBeansDaoExecute =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'execute',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateBeansDaoInitialize =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'initialize',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"propose"`
 */
export const useSimulateBeansDaoPropose =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    functionName: 'propose',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"queue"`
 */
export const useSimulateBeansDaoQueue = /*#__PURE__*/ createUseSimulateContract(
  { abi: beansDaoAbi, address: beansDaoAddress, functionName: 'queue' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansDaoAbi}__ and `functionName` set to `"veto"`
 */
export const useSimulateBeansDaoVeto = /*#__PURE__*/ createUseSimulateContract({
  abi: beansDaoAbi,
  address: beansDaoAddress,
  functionName: 'veto',
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__
 */
export const useWatchBeansDaoEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: beansDaoAbi,
  address: beansDaoAddress,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"NewAdmin"`
 */
export const useWatchBeansDaoNewAdminEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'NewAdmin',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"NewImplementation"`
 */
export const useWatchBeansDaoNewImplementationEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'NewImplementation',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"NewPendingAdmin"`
 */
export const useWatchBeansDaoNewPendingAdminEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'NewPendingAdmin',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"NewVetoer"`
 */
export const useWatchBeansDaoNewVetoerEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'NewVetoer',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalCanceled"`
 */
export const useWatchBeansDaoProposalCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalCanceled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalCreated"`
 */
export const useWatchBeansDaoProposalCreatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalCreated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalCreatedWithRequirements"`
 */
export const useWatchBeansDaoProposalCreatedWithRequirementsEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalCreatedWithRequirements',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalExecuted"`
 */
export const useWatchBeansDaoProposalExecutedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalExecuted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalQueued"`
 */
export const useWatchBeansDaoProposalQueuedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalQueued',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalThresholdBPSSet"`
 */
export const useWatchBeansDaoProposalThresholdBpsSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalThresholdBPSSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"ProposalVetoed"`
 */
export const useWatchBeansDaoProposalVetoedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'ProposalVetoed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"QuorumVotesBPSSet"`
 */
export const useWatchBeansDaoQuorumVotesBpsSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'QuorumVotesBPSSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"VoteCast"`
 */
export const useWatchBeansDaoVoteCastEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'VoteCast',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"VotingDelaySet"`
 */
export const useWatchBeansDaoVotingDelaySetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'VotingDelaySet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansDaoAbi}__ and `eventName` set to `"VotingPeriodSet"`
 */
export const useWatchBeansDaoVotingPeriodSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansDaoAbi,
    address: beansDaoAddress,
    eventName: 'VotingPeriodSet',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__
 */
export const useReadBeansToken = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"DELEGATION_TYPEHASH"`
 */
export const useReadBeansTokenDelegationTypehash =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'DELEGATION_TYPEHASH',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"DOMAIN_TYPEHASH"`
 */
export const useReadBeansTokenDomainTypehash =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'DOMAIN_TYPEHASH',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"_dataURI"`
 */
export const useReadBeansTokenDataUri = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: '_dataURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadBeansTokenBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"beanteamDAO"`
 */
export const useReadBeansTokenBeanteamDao = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'beanteamDAO',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"checkpoints"`
 */
export const useReadBeansTokenCheckpoints = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'checkpoints',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"contractURI"`
 */
export const useReadBeansTokenContractUri = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'contractURI',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"decimals"`
 */
export const useReadBeansTokenDecimals = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'decimals',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"delegates"`
 */
export const useReadBeansTokenDelegates = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'delegates',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"descriptor"`
 */
export const useReadBeansTokenDescriptor = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'descriptor',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"getApproved"`
 */
export const useReadBeansTokenGetApproved = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'getApproved',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"getCurrentVotes"`
 */
export const useReadBeansTokenGetCurrentVotes =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'getCurrentVotes',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"getPriorVotes"`
 */
export const useReadBeansTokenGetPriorVotes =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'getPriorVotes',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"getSeed"`
 */
export const useReadBeansTokenGetSeed = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'getSeed',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"isApprovedForAll"`
 */
export const useReadBeansTokenIsApprovedForAll =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'isApprovedForAll',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"isDescriptorLocked"`
 */
export const useReadBeansTokenIsDescriptorLocked =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'isDescriptorLocked',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"isMinterLocked"`
 */
export const useReadBeansTokenIsMinterLocked =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'isMinterLocked',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"isSeederLocked"`
 */
export const useReadBeansTokenIsSeederLocked =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'isSeederLocked',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"minter"`
 */
export const useReadBeansTokenMinter = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'minter',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"name"`
 */
export const useReadBeansTokenName = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"nonces"`
 */
export const useReadBeansTokenNonces = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'nonces',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"numCheckpoints"`
 */
export const useReadBeansTokenNumCheckpoints =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'numCheckpoints',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"ogBeansList"`
 */
export const useReadBeansTokenOgBeansList = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'ogBeansList',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"owner"`
 */
export const useReadBeansTokenOwner = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'owner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"ownerOf"`
 */
export const useReadBeansTokenOwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'ownerOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"proxyRegistry"`
 */
export const useReadBeansTokenProxyRegistry =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'proxyRegistry',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"seeder"`
 */
export const useReadBeansTokenSeeder = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'seeder',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"seeds"`
 */
export const useReadBeansTokenSeeds = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'seeds',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadBeansTokenSupportsInterface =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'supportsInterface',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadBeansTokenSymbol = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"tokenByIndex"`
 */
export const useReadBeansTokenTokenByIndex =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'tokenByIndex',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"tokenOfOwnerByIndex"`
 */
export const useReadBeansTokenTokenOfOwnerByIndex =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'tokenOfOwnerByIndex',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"tokenURI"`
 */
export const useReadBeansTokenTokenUri = /*#__PURE__*/ createUseReadContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'tokenURI',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadBeansTokenTotalSupply = /*#__PURE__*/ createUseReadContract(
  {
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'totalSupply',
  },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"votesToDelegate"`
 */
export const useReadBeansTokenVotesToDelegate =
  /*#__PURE__*/ createUseReadContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'votesToDelegate',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__
 */
export const useWriteBeansToken = /*#__PURE__*/ createUseWriteContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteBeansTokenApprove = /*#__PURE__*/ createUseWriteContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"burn"`
 */
export const useWriteBeansTokenBurn = /*#__PURE__*/ createUseWriteContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'burn',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"delegate"`
 */
export const useWriteBeansTokenDelegate = /*#__PURE__*/ createUseWriteContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'delegate',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"delegateBySig"`
 */
export const useWriteBeansTokenDelegateBySig =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'delegateBySig',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockDescriptor"`
 */
export const useWriteBeansTokenLockDescriptor =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockDescriptor',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockMinter"`
 */
export const useWriteBeansTokenLockMinter =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockMinter',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockSeeder"`
 */
export const useWriteBeansTokenLockSeeder =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockSeeder',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"mint"`
 */
export const useWriteBeansTokenMint = /*#__PURE__*/ createUseWriteContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
  functionName: 'mint',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"mintOriginalSupply"`
 */
export const useWriteBeansTokenMintOriginalSupply =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'mintOriginalSupply',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteBeansTokenRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useWriteBeansTokenSafeTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useWriteBeansTokenSetApprovalForAll =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setBeanteamDAO"`
 */
export const useWriteBeansTokenSetBeanteamDao =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setBeanteamDAO',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setContractURIHash"`
 */
export const useWriteBeansTokenSetContractUriHash =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setContractURIHash',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setDescriptor"`
 */
export const useWriteBeansTokenSetDescriptor =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setDescriptor',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setMinter"`
 */
export const useWriteBeansTokenSetMinter = /*#__PURE__*/ createUseWriteContract(
  { abi: beansTokenAbi, address: beansTokenAddress, functionName: 'setMinter' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setSeeder"`
 */
export const useWriteBeansTokenSetSeeder = /*#__PURE__*/ createUseWriteContract(
  { abi: beansTokenAbi, address: beansTokenAddress, functionName: 'setSeeder' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteBeansTokenTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteBeansTokenTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__
 */
export const useSimulateBeansToken = /*#__PURE__*/ createUseSimulateContract({
  abi: beansTokenAbi,
  address: beansTokenAddress,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateBeansTokenApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"burn"`
 */
export const useSimulateBeansTokenBurn =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'burn',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"delegate"`
 */
export const useSimulateBeansTokenDelegate =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'delegate',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"delegateBySig"`
 */
export const useSimulateBeansTokenDelegateBySig =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'delegateBySig',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockDescriptor"`
 */
export const useSimulateBeansTokenLockDescriptor =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockDescriptor',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockMinter"`
 */
export const useSimulateBeansTokenLockMinter =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockMinter',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"lockSeeder"`
 */
export const useSimulateBeansTokenLockSeeder =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'lockSeeder',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"mint"`
 */
export const useSimulateBeansTokenMint =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'mint',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"mintOriginalSupply"`
 */
export const useSimulateBeansTokenMintOriginalSupply =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'mintOriginalSupply',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateBeansTokenRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"safeTransferFrom"`
 */
export const useSimulateBeansTokenSafeTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'safeTransferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setApprovalForAll"`
 */
export const useSimulateBeansTokenSetApprovalForAll =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setApprovalForAll',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setBeanteamDAO"`
 */
export const useSimulateBeansTokenSetBeanteamDao =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setBeanteamDAO',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setContractURIHash"`
 */
export const useSimulateBeansTokenSetContractUriHash =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setContractURIHash',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setDescriptor"`
 */
export const useSimulateBeansTokenSetDescriptor =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setDescriptor',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setMinter"`
 */
export const useSimulateBeansTokenSetMinter =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setMinter',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"setSeeder"`
 */
export const useSimulateBeansTokenSetSeeder =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'setSeeder',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateBeansTokenTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beansTokenAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateBeansTokenTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__
 */
export const useWatchBeansTokenEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchBeansTokenApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"ApprovalForAll"`
 */
export const useWatchBeansTokenApprovalForAllEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'ApprovalForAll',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"BeanBurned"`
 */
export const useWatchBeansTokenBeanBurnedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'BeanBurned',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"BeanCreated"`
 */
export const useWatchBeansTokenBeanCreatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'BeanCreated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"BeanteamDAOUpdated"`
 */
export const useWatchBeansTokenBeanteamDaoUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'BeanteamDAOUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"DelegateChanged"`
 */
export const useWatchBeansTokenDelegateChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'DelegateChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"DelegateVotesChanged"`
 */
export const useWatchBeansTokenDelegateVotesChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'DelegateVotesChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"DescriptorLocked"`
 */
export const useWatchBeansTokenDescriptorLockedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'DescriptorLocked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"DescriptorUpdated"`
 */
export const useWatchBeansTokenDescriptorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'DescriptorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"MinterLocked"`
 */
export const useWatchBeansTokenMinterLockedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'MinterLocked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"MinterUpdated"`
 */
export const useWatchBeansTokenMinterUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'MinterUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"OgBeanMinted"`
 */
export const useWatchBeansTokenOgBeanMintedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'OgBeanMinted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchBeansTokenOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"SeederLocked"`
 */
export const useWatchBeansTokenSeederLockedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'SeederLocked',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"SeederUpdated"`
 */
export const useWatchBeansTokenSeederUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'SeederUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beansTokenAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchBeansTokenTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beansTokenAbi,
    address: beansTokenAddress,
    eventName: 'Transfer',
  })
